import {useContext} from 'react';

import {SnackbarContext} from './SnackbarProvider';

const useSnackbar = () => {
  const {showSnackbar, hideSnackbar} = useContext(SnackbarContext);

  return {showSnackbar, hideSnackbar};
};

export default useSnackbar;
